/**
 * The ONLY place the product name appears in the frontend (spec §14).
 *
 * Decided 2026-09-20 (docs/decisions/2026-09-20-product-name-carrel.md): the brand is the
 * word Carrel; `prep` anchors the domain and never appears in the wordmark or copy.
 * Because every surface reads these values rather than hard-coding a string, renaming
 * the product is an edit to this file, never a migration.
 *
 * Nothing functional may be named after the product: services, tables, buckets,
 * events and API paths stay descriptive.
 */
export const brand = {
  name: "Carrel",
  wordmark: "Carrel",
  domain: "carrelprep.com",
  supportEmail: "hello@carrelprep.com",
} as const;

export type Brand = typeof brand;
